financeModule.factory('financeService', ['$q', 'commonRESTCallService', 'AppSettings', 'FinancedQuote','erateSessionVarsService',
    function($q, commonRESTCallService, AppSettings, FinancedQuote, erateSessionVarsService) {
        var financingSvc = {};

        financingSvc.quotesToCalc = [];

        financingSvc.clearHeldFinancedQuotes = function(){
            financingSvc.quotesToCalc = [];
        }
        
        financingSvc.isProductEligible = function(quote, downPayment) {
            var deferred = $q.defer();

            //can't use product id because product is not only the thing that determines eligibility,
            // and some products (LTW) have upgrades that are eligible but base is not
            var prodId = quote.RatedProduct.InternalProductId;
            var id = quote.RatedTerms[0].SavedRateUniqueId;
            if(id) {
                var query = {quoteId: id};
                if(downPayment) query.downPayment = downPayment;

                var url = new URI(AppSettings.startSPANPlusSvcURL)
                    .segment(['altfinance', 'producteligible'])
                    .query(query);

                commonRESTCallService.getFromServer(url.toString())
                    .success(function (responseData) {
                        responseData.productId = prodId;
                        deferred.resolve(responseData);
                    }).error(function (err) {
                    deferred.reject(err);
                });
            } else {
                deferred.reject("No ID associated with quote");
            }

            return deferred.promise;
        };

        financingSvc.getEligibleProductList = function(quoteList) {
            var deferred = $q.defer();

            var eligibilityPromiseList = quoteList.map(function(quote) {
                return financingSvc.isProductEligible(quote);
            });

            $q.all(eligibilityPromiseList)
                .then(function(productFinancingStatuses) {
                    deferred.resolve(productFinancingStatuses);
                }, function(err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        financingSvc.calculateFinancing = function(product) {
            var deferred = $q.defer();

            // Assume this will always be percent - if a UI update is added to allow an option, then
            // the value of this parameter can be literally anything else in order to indicate that that
            // salesTaxAmount is a flat value, not a percent
            var salesTaxMode = "DOLLAR";
            var dealerState = erateSessionVarsService.getDealerState(); //Get financing based on state
            var url = new URI(AppSettings.startSPANPlusSvcURL)
                .segment(['altfinance', 'financing-payment', product.quoteId, ''+product.financingInfo.selectedPaymentTerm, ''+product.financingInfo.downPayment,
                    salesTaxMode, ''+dealerState, product.financingInfo.salesTaxAmount]);

            commonRESTCallService.getFromServer(url.toString())
                .success(function(responseData) {
                    angular.extend(product.financingInfo.calculatedData, responseData);
                    deferred.resolve();
                }).error(function(err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        financingSvc.getFinancedQuoteInfoById = function(quoteId) {
            return financingSvc.quotesToCalc.filter(function(element) { return element.quoteId === quoteId; })[0];
        };

        financingSvc.addQuoteForCalculation = function(quoteInfo) {
            var financedQuote = new FinancedQuote();
            financedQuote.productName = quoteInfo.name;
            financedQuote.cost = quoteInfo.cost;
            financedQuote.quoteId = quoteInfo.id;
            financedQuote.financingInfo.eligibleTerms = financedQuote.financingInfo.eligibleTerms.concat(quoteInfo.terms);
            financingSvc.quotesToCalc.push(financedQuote);
        };

        financingSvc.removeQuoteFromCalculation = function(quoteId) {
            var elementIndex;
            var filteredElements = financingSvc.quotesToCalc.filter(function(element, index) { elementIndex = index; return element.quoteId == quoteId; });


            if (filteredElements.length) {
                financingSvc.quotesToCalc.splice((elementIndex-1),  1);
            }
        };

        financingSvc.clearQuotesToCalculate = function() {
            while(financingSvc.quotesToCalc.pop()) {}
        };

        return financingSvc;
    }
]);